module.exports = __webpack_public_path__ + "static/media/tip_text_cat_flea_fr.c25c2ee1.svg";